import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';

@Injectable()
export class FacilitiesIssueService {

    private _reload$ = new Subject<void>();
    private _resourceIssues$: Observable<any> = null;
    private _resourceChoice = 0;
    private _lastIssue = 0;

    submittingToServer = false;
    objectKeys = Object.keys;
    objectEntries = Object.entries;


    constructor(
        private http: HttpClient,
        private logger: LoggerService
    ) {
        this.log('constructor', null, LogCategory.Constructor);
    }
    

    IssueEditableFieldList: any = {
        resourceId: true,
        issueId: '',
        issueLocation: true,
        describeIssue: true
    };

 

    initializeFormValidationProperities(issueForm) {
        issueForm.errors = {};
        issueForm.warnings = {};
        issueForm.touched = {};
        issueForm.editables = this.IssueEditableFieldList;
    }

    validateIssueData(issueForm, resourceArray: any[], issueArray: any[]) {
        issueForm.errors = {};
        issueForm.warnings = {};
        issueForm.editables = this.IssueEditableFieldList;

        var issuesByType: any[];
        if (!issueForm.resourceId) {
            issueForm.errors['resourceId'] = 'Please select a location.'
        }
        else
        {
            //someway to get a list of issues and setup
            if (resourceArray.length > 0 && issueArray.length > 0)
            {
                //check if we changed resource choice
                if (this._resourceChoice != issueForm.resourceId) {
                    issueForm.issueId = 0;
                    this._resourceChoice = issueForm.resourceId;
                }

                var resource = resourceArray.filter(x => x.resourceId == issueForm.resourceId);

                if (resource.length == 1) {
                    issuesByType = issueArray.filter(x => x.issueType == resource[0].resourceTypeId);
                }

                if (!issueForm.issueId) {
                    issueForm.errors['issueIds'] = 'Please select an issue.'
                }

                if (!issueForm.issueLocation) {
                    issueForm.errors['issueLocation'] = 'Please enter an issue location.';
                }

                if (!issueForm.describeIssue) {
                    issueForm.errors['describeIssue'] = 'Please describe the issue.';
                }
            }
        }

        return issuesByType;
    }  


    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.FacilitiesIssue, category);
    }

    public get resourceIssues$(): Observable<any> {
        if (this._resourceIssues$) {
        }
        else {
            this._resourceIssues$
                = this.http.get<any>(environment.apiUrl + '/facilities/resources/')
        }
        return this._resourceIssues$;
    }


    public postReportIssue(resourceForm): Observable<string> {

        const url = `${environment.apiUrl}/facilities/resource`;
        var subject = new Subject<string>();

        this.http.post<any>(url, resourceForm)
            .subscribe(
                () => subject.next('complete'),
                error => subject.next('error'),
            );

        return subject.asObservable();

    }




}
